import axios from "@/api/restApi"

/// 통계 데이터 조회
export default {
  async getSaleStats(isMonth, from, to) {
    const res = await axios.get("/api/stats/getSaleStats", {
      params: {
        isMonth,
        from,
        to,
      },
    })
    return res.data
  },

  async getUserStats(isMonth, from, to) {
    const res = await axios.get("/api/stats/getUserStats", {
      params: {
        isMonth,
        from,
        to,
      },
    })
    return res.data
  },

  async getVisitorStats(isMonth, from, to) {
    const res = await axios.get("/api/stats/getVisitorStats", {
      params: {
        isMonth,
        from,
        to,
      },
    })
    return res.data
  },

  async getPhotoShootStats(isMonth, from, to) {
    const res = await axios.get("/api/stats/getPhotoShootStats", {
      params: {
        isMonth,
        from,
        to,
      },
    })
    return res.data
  },

  async getContentsStats(isMonth, from, to) {
    const res = await axios.get("/api/stats/getContentsStats", {
      params: {
        isMonth,
        from,
        to,
      },
    })
    return res.data
  },

  async getReviewStats(isMonth, from, to) {
    const res = await axios.get("/api/stats/getReviewStats", {
      params: {
        isMonth,
        from,
        to,
      },
    })
    return res.data
  },

  async getVisitTimeStats(isMonth, from, to) {
    const res = await axios.get("/api/stats/getVisitTimeStats", {
      params: {
        isMonth,
        from,
        to,
      },
    })
    return res.data
  },
  async getSalesPerVisitorStats(isMonth, from, to) {
    const res = await axios.get("/api/stats/getSalesPerVisitorStats", {
      params: {
        isMonth,
        from,
        to,
      },
    })
    return res.data
  },
  async getRevisitStats(isMonth, from, to) {
    const res = await axios.get("/api/stats/getRevisitStats", {
      params: {
        isMonth,
        from,
        to,
      },
    })
    return res.data
  },
}
